import { getUserFavorites } from '../../services/getUserFavorites';
import { EFavoritesStatus } from '../../types/favorites';
import { TThunkAction } from '../../types/redux';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { isSameAuthenticatedSession } from '../../utils/userSession';
import { EFavoritesActionTypes } from './types';
import { updateUserFavorites } from './updateUserFavorites';

let nextRequestId = 0;

export const loadingUserFavorites = actionGenerator<EFavoritesActionTypes.LoadingUserFavorites, { requestId: number }>(
  EFavoritesActionTypes.LoadingUserFavorites,
);
export const failedUserFavorites = actionGenerator<EFavoritesActionTypes.FailedUserFavorites, { requestId: number }>(
  EFavoritesActionTypes.FailedUserFavorites,
);
export const invalidateUserFavorites = actionGenerator<EFavoritesActionTypes.InvalidateUserFavorites>(
  EFavoritesActionTypes.InvalidateUserFavorites,
);
export const resetUserFavorites = actionGenerator<EFavoritesActionTypes.ResetUserFavorites>(
  EFavoritesActionTypes.ResetUserFavorites,
);

export const loadUserFavorites = (): TThunkAction<Promise<void>> => async (dispatch, getState, context) => {
  const { favorites, user } = getState();

  if (
    !user.isAuthenticated ||
    favorites.count === 0 ||
    favorites.status === EFavoritesStatus.Loading ||
    favorites.status === EFavoritesStatus.Succeed
  ) {
    return;
  }

  const requestedUser = user;
  const requestId = ++nextRequestId;
  dispatch(loadingUserFavorites({ requestId }));

  try {
    const favoriteItems = await getUserFavorites(context);
    const currentUser = getState().user;

    if (!isSameAuthenticatedSession(requestedUser, currentUser)) {
      return;
    }

    dispatch(updateUserFavorites({ favoriteItems, requestId }));
  } catch (error) {
    context.logger.warning(error, {
      domain: 'getUserFavorites',
      message: 'Failed get user favorites',
    });

    const currentUser = getState().user;
    if (!isSameAuthenticatedSession(requestedUser, currentUser)) {
      return;
    }

    dispatch(failedUserFavorites({ requestId }));
  }
};
